import React from "react";
import WhatsAppModal from "../WhatsAppModal";

// Management edits an existing connection; creating one uses the company's own Connections page.
export default function WhatsAppModalAdmin(props) {
 return props.open && props.whatsAppId ? <WhatsAppModal {...props} adminMode /> : null;
}
